import {
  referenceNumberList,
  referenceString,
  type TaskReferenceResolver,
  type TaskReferenceRoute,
} from '@src/features/tasks';

/**
 * Where a task about an absence opens.
 *
 * The payload's shape is the Absence Tool's own, so reading it belongs here
 * rather than in the task feature: the days it names, and how far they run.
 * Both ends travel with the reference because the calendar loads a window at a
 * time -- without them it could not tell a day that is off screen from one
 * that has been deleted. `useAbsenceRouteFocus` reads back what is written
 * here, which is the other reason to keep the two in one feature.
 */
export const absenceTaskReference: TaskReferenceResolver = (
  data,
): TaskReferenceRoute | null => {
  const absenceIds = referenceNumberList(data.absenceIds);
  const date = referenceString(data.date);
  if (!absenceIds.length || !date) {
    // Nothing to point at any more -- the days were given back and deleted.
    // The calendar is still the right place to land.
    return { to: '/absence' };
  }

  return {
    to: '/absence',
    search: {
      absenceIds: absenceIds.join(','),
      date,
      dateTo: referenceString(data.dateTo) ?? date,
    },
  };
};
